import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.Yy/yDL',
    defaultMessage: 'Reset password',
  },
  description: {
    id: 'studio.h5YteA',
    defaultMessage: 'Request a password reset for your Appsemble user',
  },
});
